import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
var bodymovin
if (process.browser) {
  bodymovin = require('bodymovin')
}

const Container = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: ${props => (props.visible ? 'table' : 'none')};
  background: rgba(0, 0, 0, 0.4);
  left: 0;
  top: 0;
  z-index: 5;
`

const LoaderContainer = styled.div`
  display: table-cell;
  vertical-align: middle;
`

const LoaderSpining = styled.div`
  margin-left: calc((100% - ${props => props.width}px)/2);
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`

class Loader extends Component {
  constructor (props) {
    super(props)
    this.container = null
    this.params = {
      container: null,
      renderer: 'svg',
      prerender: true,
      loop: true,
      autoplay: true,
      path: '/loader.json'
    }
  }

  componentDidMount () {
    if (process.browser) {
      this.params.container = this.container
      this.anim = bodymovin.loadAnimation(this.params)
      window.onresize = this.anim.resize.bind(this.anim)
    }
  }

  render () {
    const { visible, height, width } = this.props
    return (
      <Container visible={visible} {...this.props}>
        <LoaderContainer height={height} width={width}>
          <LoaderSpining
            height={height}
            width={width}
            innerRef={div => {
              this.container = div
            }}
          />
        </LoaderContainer>
      </Container>
    )
  }
}

Loader.propTypes = {
  visible: PropTypes.bool,
  width: React.PropTypes.number,
  height: React.PropTypes.number
}

Loader.defaultProps = {
  width: 100,
  height: 100
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader/index.js